import { AfterViewInit, Component, ElementRef, Inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-double-check-dialog',
  templateUrl: './double-check-dialog.component.html',
  styleUrls: ['./double-check-dialog.component.css']
})
export class DoubleCheckDialogComponent implements AfterViewInit {

  @ViewChildren('input') inputs: QueryList<ElementRef<HTMLInputElement>>;

  invalidValue: boolean = false;

  allowedChars = '';

  formArray: FormArray = new FormArray([]);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DoubleCheckDialogComponentInputData,
    private _ref: MatDialogRef<DoubleCheckDialogComponent>,
    private _formBuilder: FormBuilder
  ) {
    for (let index = 0; index < this.data.doubleCheckValue.length; index++) this.formArray.push(this._formBuilder.control(null));
    if(data.mode === 'alpha' || data.mode === 'alphanumeric' || data.mode === 'all') this.allowedChars += 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    if(data.mode === 'numeric' || data.mode === 'alphanumeric' || data.mode === 'all') this.allowedChars += "0123456789";
    if(data.mode === 'all') this.allowedChars += "!§$%&/()?#_-.,";
  }

  abort = () => this.close();

  close = () => this._ref.close();

  confirm = () => {
    this._ref.close(Object.values(this.formArray.controls).map(x => x.value).join('') === this.data.doubleCheckValue);
  }

  jumpToNext(event: KeyboardEvent, index: string) {
    event.preventDefault();
    event.stopPropagation();
    if(this.allowedChars.indexOf(event.key) > -1){
      this.formArray.controls[parseInt(index)].setValue(event.key);
      let next = parseInt(index)+1;
      if (next === this.formArray.length) {
        let value = Object.values(this.formArray.controls).map(x => x.value + '').join('');
        if(value === this.data.doubleCheckValue) this.confirm();
        else {
          this.invalidValue = true;
          this.inputs.get(0).nativeElement.focus();
        }
      } else this.inputs.get(next).nativeElement.focus();
    }
  }

  ngAfterViewInit(): void {
    this.inputs.get(0).nativeElement.focus();
  }

}

export class DoubleCheckDialogComponentInputData {
  text: string;
  title: string;
  icon: string;
  doubleCheckValue: string;
  mode: 'alpha' | 'numeric' | 'alphanumeric' | 'all';
}
